import { CpcOrganizationunitModel } from "./cpcorganizationunit.model";

export class ClientPolicyControlExceptionModel {
    cpcId: string = null;
    cpcOrganizationunitId: string = null;
    cpcCheckMethodId: string = null;
    cpcCaseTypeId: string = null;
    cpcOrganizationunit = new CpcOrganizationunitModel();
}